export default [
    {
        key: 'validation',
        components: [
            {
                key: 'validateOn',
                ignore: true
            },
            {
                key: 'unique',
                ignore: true
            },
            {
                key: 'errorLabel',
                ignore: true
            },
            {
                key: 'validate.customMessage',
                ignore: true
            },
            {
                key: 'errors',
                ignore: true
            },
            {
                key: 'json-validation-json',
                ignore: true
            },
            {
                key: 'custom-validation-js',
                ignore: true
            },
            {
                label: 'Custom Errors',
                editor: 'ace',
                spellcheck: false,
                tableView: false,
                key: 'custom_errors',
                type: 'textarea',
                input: true,
                as: 'json',
            },
            {
                label: 'HTML',
                attrs: [
                    {
                        attr: '',
                        value: '',
                    },
                ],
                content: '<div ref="html" class="formio-component-htmlelement">\r\n          <p>This allows you to set different custom error messages for different errors e.g.</p>\r\n\r\n<pre>{\r\n  "quantity_min": "{<span>{ quantitymin }} is the minimum amount of this product.",\r\n  "quantity_max": "{<span>{ quantitymax }} is the maximum amount of this product."\r\n}</span></span></pre>\r\n\r\n          <p>You can set the following keys (among others):</p>\r\n          <ul>\r\n            <li>q<span>uantity_min</span></li>\r\n            <li>q<span>uantity_max</span></li>\r\n            <li>a<span>mount_min</span></li>\r\n            <li>a<span>mount_max</span></li>\r\n          </ul>\r\n\r\n          <p>Depending on the error message some of the following template variables can be used in the script:</p>\r\n          <ul>\r\n           <li><code>{<span>{ l<span>abel }}</span></span></code></li>\r\n           <li><code>{<span>{ q<span>uantitymin}}</span></span></code></li>\r\n           <li><code>{<span>{ q<span>uantitymax }}</span></span></code></li>\r\n           <li><code>{<span>{ a<span>mountmin }}</span></span></code></li>\r\n           <li><code>{<span>{ a<span>mountmax }}</span></span></code></li>\r\n           <li><code>{<span>{ c<span>urrency }}</span></span></code></li>\r\n          </ul>\r\n        </div>',
                refreshOnChange: false,
                key: 'html',
                type: 'htmlelement',
                input: false,
                tableView: false,
            },
        ]
    },
];
